export default {
  tipoProposta: {
    ACIDENTE: {
      id: 1,
      descricao: 'Acidente'
    },
    ACIDENTE_ROUBO: {
      id: 2,
      descricao: 'Acidente e Roubo'
    },
    ROUBO: {
      id: 3,
      descricao: 'Roubo'
    },
    DECLARACAO_SEGURO: {
      id: 4,
      descricao: 'Declaração de Seguro'
    },
    OUTROS: {
      id: 5,
      descricao: 'Outros arquivos'
    },
    list: [
      this.ACIDENTE,
      this.ACIDENTE_ROUBO,
      this.ROUBO,
      this.DECLARACAO_SEGURO,
      this.OUTROS
    ]
  },
  tipoArquivo: {
    PROPOSTA: {
      id: 1,
      descricao: 'Proposta'
    },
    APOLICE: {
      id: 2,
      descricao: 'Apólice'
    },
    OUTROS: {
      id: 3,
      descricao: 'Outros'
    },
    PROPOSTA_ASSINADA: {
      id: 4,
      descricao: 'Proposta Assinada'
    },
    DECLARACAO_SEGURO: {
      id: 5,
      descricao: 'Declaração de Seguro'
    },
    list: [
      this.PROPOSTA,
      this.APOLICE,
      this.OUTROS,
      this.PROPOSTA_ASSINADA,
      this.DECLARACAO_SEGURO
    ]
  },
  arquivoParaByteArray: async function(arquivo) {
    var reader = new FileReader();
    return new Promise((resolve, reject) => {
      var fileByteArray = [];
      reader.readAsArrayBuffer(arquivo);
      reader.onerror = function () {
        console.log('Ocorreu um erro');
        reject(null);
      }
      reader.onloadend =  function (evt) {
        if (evt.target.readyState == FileReader.DONE) {
          var arrayBuffer = evt.target.result,
            array = new Uint8Array(arrayBuffer);
          for (var i = 0; i < array.length; i++) {
            fileByteArray.push(array[i]);
          }
          resolve(fileByteArray);
        }
      }
    });
  },
}


// WEBPACK FOOTER //
// ./src/components/pages/solicitacao-consulta/ArquivoFunctions.js